// extracted by mini-css-extract-plugin
var _1 = "mobile";
var _2 = "quote-author";
var _3 = "quote-container";
var _4 = "quote-text";
export { _1 as "mobile", _2 as "quote-author", _3 as "quote-container", _4 as "quote-text" }
